module.exports = __webpack_public_path__ + "img/aiIcon-ocr.ca45c8a9.svg";